import { render, staticRenderFns } from "./OverlayLocationEdit.vue?vue&type=template&id=a8842b14&"
import script from "./OverlayLocationEdit.vue?vue&type=script&lang=js&"
export * from "./OverlayLocationEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/fwgcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a8842b14')) {
      api.createRecord('a8842b14', component.options)
    } else {
      api.reload('a8842b14', component.options)
    }
    module.hot.accept("./OverlayLocationEdit.vue?vue&type=template&id=a8842b14&", function () {
      api.rerender('a8842b14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/fwgcontao/js/pages/OverlayLocationEdit.vue"
export default component.exports